import { createElement } from '../../../core/dom/helpers.js';

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const readonlyDriver = {
  type: 'readonly',
  mount(container, ctx) {
    const { def } = ctx;
    const readonlyDef = /** @type {import('../../../contracts/forms.js').ReadonlyFieldDef} */ (def);

    /** @type {unknown} */
    let currentValue = ctx.value !== undefined ? ctx.value : '';

    const display = createElement('span', { class: 'readonly-driver' });
    const hiddenInput = /** @type {HTMLInputElement} */ (createElement('input', {
      type: 'hidden',
      name: def.key,
    }));
    container.appendChild(display);
    container.appendChild(hiddenInput);

    function updateDisplay() {
      const formatted = readonlyDef.format
        ? readonlyDef.format(currentValue)
        : (currentValue == null ? '' : String(currentValue));
      display.textContent = formatted;
      hiddenInput.value = currentValue == null ? '' : String(currentValue);
    }

    updateDisplay();

    return {
      setValue(value) {
        currentValue = value;
        updateDisplay();
      },
      getValue() {
        return currentValue;
      },
      setErrors() {
        // errors rendered by host
      },
      destroy() {
        display.remove();
        hiddenInput.remove();
      },
      clearValue() {
        currentValue = '';
        updateDisplay();
      },
      setAriaInvalid(invalid) {
        display.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      },
    };
  },
};
